module.exports = __webpack_public_path__ + "img/48-white.4dde3c12.svg";